import { render, staticRenderFns } from "./GlassesIcon.vue?vue&type=template&id=3decf441&"
import script from "./GlassesIcon.vue?vue&type=script&lang=ts&"
export * from "./GlassesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports